// DEBUG source for the migrated LMUTV subtree. The original standalone app
// exported this from its index.tsx; copied components import `{ DEBUG }` from the
// lmutv root, so we re-provide it here.
export const DEBUG = process.env.NODE_ENV === "development";
